export function contractEndDate(start: string, months: number): string {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(start) || !Number.isInteger(months) || months < 1) return "";
  const begins = new Date(start + "T00:00:00Z");
  if (!Number.isFinite(begins.getTime()) || begins.toISOString().slice(0, 10) !== start) return "";
  const ends = new Date(begins);
  ends.setUTCDate(1);
  ends.setUTCMonth(ends.getUTCMonth() + months);
  const lastDay = new Date(ends);
  lastDay.setUTCMonth(lastDay.getUTCMonth() + 1);
  lastDay.setUTCDate(0);
  ends.setUTCDate(Math.min(begins.getUTCDate(), lastDay.getUTCDate()));
  return Number.isFinite(ends.getTime()) && ends.getUTCFullYear() <= 9999 ? ends.toISOString().slice(0, 10) : "";
}

export function contractMonths(start: string, end: string): number {
  const months = (Number(end.slice(0, 4)) - Number(start.slice(0, 4))) * 12 + Number(end.slice(5, 7)) - Number(start.slice(5, 7));
  return contractEndDate(start, months) === end && end !== "" ? months : 0;
}

export function formatCalendarDate(value: string, locales?: Intl.LocalesArgument, options?: Intl.DateTimeFormatOptions) {
  return new Date(`${value.slice(0, 10)}T00:00:00Z`).toLocaleDateString(locales, { ...options, timeZone: "UTC" });
}
